import { DomeComponent, DomeManipulator, DomeRouter, React } from "@lexriver/dome";
import { JsonProductCategory } from "../json-data-types/JsonProductCategory";
import { UrlGenerator } from "../UrlGenerator";
import { SubMenu } from "./SubMenu";
import css from './MenuItem.m.scss'
import { Settings } from "../../Settings";
import { ServerCategories } from "../server-queries/ServerCategories";
import { Icon } from "./Icon";
import { EnumIconNames } from "../enums/EnumIconNames";

interface Attrs{
    category:JsonProductCategory
}

export class MenuItemProductCategory extends DomeComponent<Attrs>{
    protected refContainer!:HTMLDivElement
    protected refMenuItemText!:HTMLDivElement
    protected refCounter!:HTMLSpanElement
    protected refSubMenu!:SubMenu

    protected url:string = ''

    render(){

        this.url = UrlGenerator.productsByCategoryWithDefaultParameters({category: this.attrs.category})
        const link = (
                <a href={this.url} onClick={(e) => this.onLinkClick(e)}>
                    {this.attrs.category.name}
                    {/* <span class={css.counter}>{attrs.category.countOfProducts}</span> */}
                </a>
        )
        if(this.attrs.category.nameHtml && this.attrs.category.nameHtml.length>2){
            link.innerHTML = this.attrs.category.nameHtml
        }

        return(
            <div ref={ref => this.refContainer = ref} class={css.menuItem}>
                <div ref={ref =>this.refMenuItemText = ref} class={css.menuItemText} onClick={() => this.onMenuItemClick() }>
                    <div>
                        {link}
                    </div>
                    <div class={css.counter} ref={ref => this.refCounter = ref}></div>
                </div>
            </div>
        )
    }

    protected onLinkClick(e){
        e.preventDefault()
    }


    protected onMenuItemClick(){
        if(this.refSubMenu){
            this.refSubMenu.show()
        } else {
            DomeRouter.navigate(Settings.addPrefixForUrl(this.url))
        }
    }

    async afterRender(){
        if(await ServerCategories.checkIfCurrentUserCanSeeCategoryAsync(this.attrs.category) === false){
            await DomeManipulator.removeElementAsync(this.rootElement)
            return
        }
        
        const subCategories = await ServerCategories.getAllSubcategoriesAsync(this.attrs.category.id)
        if(subCategories.length === 0) {
            return
        }

        await DomeManipulator.replaceAllChildrenAsync(this.refCounter, <>{subCategories.length}<Icon iconName={EnumIconNames.RightOpen} /></>)

        await DomeManipulator.appendChildAsync(this.refContainer,
            <SubMenu ref={ref => this.refSubMenu = ref}>
                {subCategories.map(category => <MenuItemProductCategory category={category} />)}
            </SubMenu>
        )
    }

}